import React from 'react';
import { Button } from '../../../@/components/ui/button';
import { Drawer,  DrawerContent, DrawerDescription, DrawerHeader} from '../../../@/components/ui/drawer';

interface AnalyticDrawerProps {
    isDrawerOpen: boolean;
    setIsDrawerOpen: (open: boolean) => void;
    cardTitle?: string;
    onCategorySelect?: (category: string) => void;
}
  
export default function AnalyticDrawer({ 
    isDrawerOpen, 
    setIsDrawerOpen,
    cardTitle,
    onCategorySelect
}: AnalyticDrawerProps) {
  const categories = [
    { label: "Total Revenue", icon: "💰" },
    { label: "Total Orders", icon: "📦" },
    { label: "AI Inquiries", icon: "🤖" },
    { label: "Users Engaged", icon: "👥" },
    { label: "New Orders", icon: "✨" },
    { label: "Partial Orders", icon: "🔄" },
    { label: "Cancelled Orders", icon: "❌" },
    { label: "Confirmed Orders", icon: "✅" }
  ];

  const handleCategorySelect = (category: string) => {
    onCategorySelect?.(category);
    setIsDrawerOpen(false);
  };

  return (
    <Drawer open={isDrawerOpen} onOpenChange={setIsDrawerOpen}>
      <DrawerContent>
        <DrawerHeader>
          <DrawerDescription className="text-center">
            {cardTitle ? `Select a category for ${cardTitle}` : "Select a category to view details"}
          </DrawerDescription>
        </DrawerHeader>
        
        <div className="grid grid-cols-2 gap-4 p-4">
          {categories.map((category) => (
            <Button 
              key={category.label} 
              variant="outline" 
              onClick={() => handleCategorySelect(category.label)}
              className="flex items-center justify-center space-x-6 h-12 rounded-lg text-sm font-medium transition-all hover:bg-primary hover:text-white"
            >
              <span className="text-xl">{category.icon}</span>
              <span>{category.label}</span>
            </Button>
          ))}
        </div>
      </DrawerContent>
    </Drawer>
  );
};